import { GET_LOADER } from "../actions/types";
const initialState = "false";
export default function loaderReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LOADER:
      return {
        payload,
      };
    default:
      return {
        state,
      };
  }
}
